/**
 * Focus Outside component
 *
 * Similar to click_outside.js but for focus events
 *
 * @author    Matthew Hamlin <mhamlin@wayfair.com>
 * @copyright 2018 Wayfair LLC - All rights reserved
 */
import {Component} from 'react';
import PropTypes from 'prop-types';

export default class FocusOutside extends Component {
  static propTypes = {
    // A render callback called with a function to assign a ref to the top most
    // html wrapper
    children: PropTypes.func.isRequired,
    // A callback called only when the user focuses outside of the top most html wrapper
    onFocusOutside: PropTypes.func,
  };
  static defaultProps = {
    onFocusOutside() {},
  };
  componentDidMount() {
    document.addEventListener('focus', this.handleFocus, true);
  }
  componentWillUnmount() {
    document.removeEventListener('focus', this.handleFocus, true);
  }

  assignRef = (node) => {
    this.container = node;
  };

  handleFocus = (event) => {
    if (!this.container || this.container.contains(event.target)) {
      return;
    } else {
      this.props.onFocusOutside(event);
    }
  };
  render() {
    return this.props.children(this.assignRef);
  }
}
